(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["frequently-bought-together"] && !Shopify.designMode) return;
  try {
    function fbtFormatMoney(cents, format) {
  if (typeof cents === 'string') cents = cents.replace('.', '');

  function formatWithDelimiters(number, thousands, decimal) {
    thousands = typeof thousands === 'undefined' ? ',' : thousands;
    if (isNaN(number) || number === null) return 0;
    number = Math.round(number / 100.0).toString();
    return number.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
  }

  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || '${{amount}}';
  const match = formatString.match(placeholderRegex);
  let value = formatWithDelimiters(cents, ',');

  if (match && (match[1] === 'amount_with_comma_separator' || match[1] === 'amount_no_decimals_with_comma_separator')) {
    value = formatWithDelimiters(cents, '.');
  }

  return formatString.replace(placeholderRegex, value);
}

class FrequentlyBoughtTogetherForm extends HTMLElement {
  constructor() {
    super();
    this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
    this.checkboxes = Array.from(this.querySelectorAll('[data-fbt-checkbox]'));
    this.submitButton = this.querySelector('[data-fbt-submit]');
    this.submitLabel = this.querySelector('[data-fbt-submit-label]');
    this.totalSaleEl = this.querySelector('[data-fbt-total-price]');
    this.totalCompareEl = this.querySelector('[data-fbt-total-compare]');
    this.errorWrapper = this.querySelector('[data-fbt-error]');
    this.errorText = this.querySelector('[data-fbt-error-text]');
    this.spinner = this.querySelector('.loading-overlay__spinner');
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    this.checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', this.updateTotals.bind(this));
    });

    this.addEventListener('submit', this.onSubmit.bind(this));

    this.updateTotals();
  }

  getSelected() {
    return this.checkboxes.filter((checkbox) => checkbox.checked && !checkbox.disabled);
  }

  updateTotals() {
    const selected = this.getSelected();
    let saleTotal = 0;
    let compareTotal = 0;

    selected.forEach((checkbox) => {
      const price = parseInt(checkbox.dataset.price, 10) || 0;
      const comparePrice = parseInt(checkbox.dataset.comparePrice, 10) || 0;
      saleTotal += price;
      compareTotal += comparePrice > price ? comparePrice : price;
    });

    if (this.totalSaleEl) this.totalSaleEl.textContent = fbtFormatMoney(saleTotal, this.moneyFormat);

    if (this.totalCompareEl) {
      if (compareTotal > saleTotal) {
        this.totalCompareEl.textContent = fbtFormatMoney(compareTotal, this.moneyFormat);
        this.totalCompareEl.hidden = false;
      } else {
        this.totalCompareEl.hidden = true;
      }
    }

    if (this.submitButton) {
      if (selected.length === 0) {
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.disabled = true;
      } else {
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.disabled = false;
      }
    }
  }

  hideErrors() {
    if (this.errorWrapper) this.errorWrapper.hidden = true;
    if (this.errorText) this.errorText.textContent = '';
  }

  showError(message) {
    if (this.errorWrapper) this.errorWrapper.hidden = false;
    if (this.errorText) this.errorText.textContent = message;
  }

  onSubmit(event) {
    event.preventDefault();
    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

    const selected = this.getSelected();
    if (selected.length === 0) return;

    this.hideErrors();
    this.submitButton.setAttribute('aria-disabled', 'true');
    this.submitButton.classList.add('loading');
    if (this.spinner) this.spinner.classList.remove('hidden');

    const items = selected.map((checkbox) => ({
      id: parseInt(checkbox.dataset.variantId, 10),
      quantity: 1,
    }));

    const body = {
      items,
    };

    if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
      body.sections = this.cart.getSectionsToRender().map((section) => section.id);
      body.sections_url = window.location.pathname;
      if (typeof this.cart.setActiveElement === 'function') {
        this.cart.setActiveElement(document.activeElement);
      }
    }

    const cartAddUrl =
      (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';

    fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          const message =
            (response.description) ||
            (response.message) ||
            'Something went wrong adding the bundle to your cart.';
          this.showError(message);
          return;
        }

        if (this.submitLabel) this.submitLabel.classList.add('hidden');

        if (this.cart && typeof this.cart.renderContents === 'function') {
          this.cart.classList.remove('is-empty');
          this.cart.renderContents(response);
          if (typeof this.cart.open === 'function') {
            this.cart.open();
          }
        } else if (window.routes && window.routes.cart_url) {
          window.location = window.routes.cart_url;
        } else {
          window.location = '/cart';
        }

        document.dispatchEvent(
          new CustomEvent('fbt:added', { bubbles: true, detail: { response } })
        );
      })
      .catch((error) => {
        console.error(error);
        this.showError('Something went wrong adding the bundle to your cart.');
      })
      .finally(() => {
        this.submitButton.classList.remove('loading');
        if (this.spinner) this.spinner.classList.add('hidden');
        if (this.submitLabel) this.submitLabel.classList.remove('hidden');
        this.submitButton.removeAttribute('aria-disabled');
      });
  }
}

if (!customElements.get('frequently-bought-together-form')) {
  customElements.define('frequently-bought-together-form', FrequentlyBoughtTogetherForm);
}
  } catch(e) { console.error(e); }
})();

})();
